import { Grid, Stack, Chip, Box, Button} from "@mui/material"
import RTEInput from '../../../components/RichTextEditor'
import Input from "../../../components/Input"


const Finalize = ({fieldValues, handleIndexedOnChange, handleAddNew, handleDelete}) =>{
    const fields = [
        {name:'title', label:'Tite', type: 'input'},
        {name:'content', label:'Content', type: 'rte'},
    ]
    const handleOnChange = (name, value, index) =>{
        handleIndexedOnChange('other', index, name, value)
    }
    const handleRTEChange = (value, name, index) =>{
        if(value){
            handleIndexedOnChange('other', index, name, value)
        }
    }
    return <Grid container>
        <Grid item xs={12} px={3} display={'flex'} justifyContent={'space-between'}>
        <Stack direction="row" spacing={1}>{fieldValues['other'].map((values, index)=>{
                return <Chip label={`Extra ${index + 1}`} onDelete={()=>handleDelete('other', index)}/>
            })}</Stack>
            <Box><Button variant="contained" onClick={()=>handleAddNew('other')}>Add New</Button></Box>
        </Grid>
        {fieldValues['other'].map((values, fieldIndex)=>{
            return fields.map((field, index)=>{
                return <Grid item xs={field.type === 'rte' ?12 :6} p={3}>
                {field.type === 'input' && <Input name={field.name} label={field.label} value={values[field.name]} key={index} index={fieldIndex} handleOnChange={handleOnChange}/>}
                {field.type === 'rte' && <RTEInput name={field.name} label={field.label} value={values[field.name]} key={index} index={fieldIndex} handleOnChange={handleRTEChange}/>}             
                </Grid>
            })
        })}
    </Grid>
}

export default Finalize